import { httpRequest } from "@/lib";
import { FinanceEntryResponse } from "@/types";
import { useQuery } from "@tanstack/react-query";

type Props = {
  accountId: string;
  page: string | null;
  per_page?: number | null;
  categoryId: string;
  patientId: string;
  procedureId: string;
  startDate: string;
  endDate: string;
  type: string;
};

async function fetchFinanceEntriesByIdAccount({
  accountId,
  page,
  per_page,
  categoryId,
  patientId,
  procedureId,
  endDate,
  startDate,
  type,
}: Props): Promise<FinanceEntryResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page}`;
  const response = await httpRequest.get<FinanceEntryResponse>(
    `/finance-entries?accountId=${accountId}&startDate=${startDate}&endDate=${endDate}&${pageParams}&categoryId=${categoryId}&patientId=${patientId}&procedureId=${procedureId}&type=${type}`
  );
  return response.data;
}

export function useFetchFinanceEntriesByIdAccountQuery({
  accountId,
  page,
  per_page,
  categoryId,
  patientId,
  procedureId,
  endDate,
  startDate,
  type,
}: Props) {
  const entriesQuery = useQuery({
    queryKey: [
      "finance-entries",
      accountId,
      page,
      per_page,
      patientId,
      procedureId,
      categoryId,
      endDate,
      startDate,
      type,
    ],
    queryFn: () =>
      fetchFinanceEntriesByIdAccount({
        accountId,
        page,
        per_page,
        categoryId,
        patientId,
        procedureId,
        endDate,
        startDate,
        type,
      }),
    keepPreviousData: false,
    enabled: !!accountId,
  });

  return {
    ...entriesQuery,
    data: entriesQuery.data,
  };
}
